module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_2_C.9688aad4.png";